import GoogleAdTop from "@unisearch/common/google_ad_top";
import { readingTime, remove_tags } from "@unisearch/helpers/utils";
import Link from "next/link";
import { useRouter } from "next/router";
import PageInfo from "../common/page_info";
import styles from "./study_banner_two.module.scss";

export const StudyBannerTwo = ({ pageData, name = "", linkType }) => {
  const arr = ["united-states", "united-kingdom"];
  const link = useRouter();
  const { asPath } = link;

  return (
    <section className={`${styles.section_study_banner} !pt-7`}>
      <div className="container">
        <GoogleAdTop />
        <div className={styles.hero_container}>
          <p className={styles.sub_heading}>
            <span className="bold">{pageData?.referenceColumnName}</span>{" "}
            {(pageData?.pageContent && readingTime(pageData.pageContent)) || 1}{" "}
            min read
          </p>
          <h1 className="heading-one">{pageData.pageTitle}</h1>
          {pageData?.pageShortDescription && (
            <div className={styles.description}>
              {remove_tags(pageData.pageShortDescription)}
            </div>
          )}
          {/* breadcrumbs */}
          <div className={styles.breadcrumbs}>
            <Link legacyBehavior href="/">
              <a>
                <span>Home</span>
              </a>
            </Link>
            {" - "}
            <Link legacyBehavior href={`/${linkType}/${name}`}>
              <a>
                <span>
                  {linkType}{" "}
                  {linkType === "study"
                    ? `in ${arr.includes(name) ? "the" : ""}`
                    : ""}{" "}
                  {pageData?.referenceColumnName}
                </span>
              </a>
            </Link>
            {" - "}

            <p className={styles.active}>{pageData?.pageTitle}</p>
          </div>
          {/* Short info */}
          {asPath !== `/${linkType}/${name}` && (
            <>
              <div className={styles.short_info_desktop}>
                <PageInfo data={pageData} />
              </div>
            </>
          )}
          {/* Short info */}
          {/* <div className={styles.short_info}> */}
          {/* <a href="#">
              <div className={`${styles.author} ${styles.info_item}`}>
                <div className={styles.icon}>
                  <img src="/favicon.jpg" alt="author" />
                </div>
                <div className={styles.text}>
                  <span className={styles.name}>Author</span>
                  <span className={styles.desc}>{pageData?.author?.name}</span>
                </div>
              </div>
            </a> */}
          {/* <a href="#">
              <div className={`${styles.date} ${styles.info_item}`}>
                <div className={styles.icon}>
                  <CalenderIcon />
                </div>
                <div className={styles.text}>
                  <span className={styles.name}>Published</span>
                  <span className={styles.desc}>
                    Aug 10, 2021 
                    {pageData?.publishDate?.substring(0, 10) || ""}
                  </span>
                </div>
              </div>
            </a> */}
          {/* <a href="#">
              <div className={`${styles.comment} ${styles.info_item}`}>
                <div className={styles.icon}>
                  <Conversation />
                </div>
                <div className={styles.text}>
                  <span className={styles.name}>100 Comments</span>
                  <span className={styles.desc}>Join the Conversation</span>
                </div>
              </div>
            </a> */}
          {/* {pageData?.fakeView && (
              <div>
                <div className={`${styles.view} ${styles.info_item}`}>
                  <div className={styles.icon}>
                    <Viewer />
                  </div>
                  <div className={styles.text}>
                    <span className={styles.name}>View</span>
                    <span className={styles.desc}>{pageData?.fakeView}</span>
                  </div>
                </div>
              </div>
            )} */}
          {/* <button className={styles.info_button}>
              <BiPlus />
              <span>Follow</span>
            </button> */}
          {/* </div> */}
        </div>
      </div>
    </section>
  );
};

export default StudyBannerTwo;
